module.exports = __webpack_public_path__ + "static/media/Tasks_Detail.fa0f1cbe.png";